var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "custom-icon" },
    [
      !_vm.imageIcons[_vm.name]
        ? _c("md-icon", [_vm._v(_vm._s(_vm.name))])
        : _vm._e(),
      _vm._v(" "),
      !!_vm.imageIcons[_vm.name]
        ? _c("img", {
            attrs: {
              src:
                "/imgs/icons/" +
                _vm.imageIcons[_vm.active ? _vm.name + "_active" : _vm.name]
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a2cf94c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a2cf94c","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/widgets/CustomIconComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3a2cf94c","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/widgets/CustomIconComponent.vue
// module chunks = 1 2 3